export default "__VITE_ASSET__CpkbPv1$__"